// import React from 'react'
// import USTemplateDefault from 'src/components/template/us'
// import { networkLogos } from 'src/constants/networkLogos'
// import { leagueIds, sportIds, teamIds } from 'src/constants/personalizationIds'

// TEMPORARY NBC DISPUTE
import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => <RedirectTemplate location={props.location} destination="/tv/" />
